﻿import mixin from './mixin.js';
import axios from 'axios';
import constants from '../constants.js';
import Datepicker from 'vanillajs-datepicker/Datepicker';
import nl from 'vanillajs-datepicker/locales/nl';
Object.assign(Datepicker.locales, nl);

const datePickerOptions = {
    autohide: true,
    format: 'dd-mm-yyyy',
    nextArrow: '<i class="fa-solid fa-angle-right"></i>',
    prevArrow: '<i class="fa-solid fa-angle-left"></i>',
    orientation: 'top',
    minDate: new Date()
}

const formatter = new Intl.DateTimeFormat('nl-NL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
});

const ticketApp = {
    mixins: [mixin],
    data() {
        return {
            dataApi: '',
            dataGeneralApi: '',
            dataSortKey: '',
            dataSortDirection: '',
            culture: 'nl-NL',
            language: 'nl',
            delimiter: '-',
            constants: constants,
            loading: false,
            datepicker: null,
            dayTickets: true,
            chosenDate: '',
            dayItems: [],
            dayUrl: '',
            eveningItems: {},
            eveningMovies: [],
            eveningUrl: '-1'
        }
    },
    computed: {
        orderItems() {
            if (!this.dataSortKey && !this.dataSortDirection) return [];
            return [
                {
                    Key: this.dataSortKey,
                    Direction: this.dataSortDirection,
                }
            ]
        },
        queryModel() {
            return {
                OrderItems: this.orderItems,
                Text: ''
            }
        },
        allDayDates() {
            if (!this.dayItems.length) return [];
            let dates = this.dayItems.map(date => this.reverseDate(date[this.constants.keys.date]));
            return dates;
        },
        allEveningDates() {
            if (!Object.keys(this.eveningItems).length) return [];
            let dates = [...new Set(Object.keys(this.eveningItems).map(key => new Intl.DateTimeFormat(this.culture, {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }).format(new Date(key))))];
            return dates;
        }

    },
    methods: {
        async init() {
            this.loading = true;
            if (this.$el.dataset.currentculture) this.culture = this.$el.dataset.currentculture;
            this.language = this.culture.split('-')[0];
            this.delimiter = this.culture === this.constants.culture.dutch ? '-' : '/';
            if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api + '?culture=' + this.culture;
            if (this.$el.dataset.generalticketsapi) this.dataGeneralApi = this.$el.dataset.generalticketsapi;
            if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
            if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
            if (this.$el.dataset.isevening) this.dayTickets = this.$el.dataset.isevening === 'false';

            if (this.dayTickets) {
                const response = await this.fetchData(this.dataGeneralApi);
                if (response && response.data) {
                    this.dayItems = response.data.items;
                    this.loading = false;
                }
            } else {
                const response = await this.fetchData(this.dataApi);
                if (response && response.data) {
                    this.eveningItems = response.data;
                    this.loading = false;
                }
            }

            this.$nextTick(() => {
                if (this.datepicker === null && this.$refs.datepicker) {
                    const self = this;
                    datePickerOptions.language = this.language;
                    datePickerOptions.format = this.culture === this.constants.culture.dutch ? 'dd-mm-yyyy' : 'dd/mm/yyyy';
                    if (self.dayTickets) {
                        datePickerOptions.datesDisabled = function (date) {
                            return !self.allDayDates.includes(new Intl.DateTimeFormat(self.culture, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(date));
                        }
                    } else {
                        datePickerOptions.datesDisabled = function (date) {
                            return !self.allEveningDates.includes(new Intl.DateTimeFormat(self.culture, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(date));
                        }
                    }
                    this.datepicker = new Datepicker(this.$refs.datepicker, datePickerOptions);
                    this.$refs.datepicker.addEventListener('changeDate', (e) => {
                        if (e.detail.date !== undefined) {
                            self.chosenDate = new Intl.DateTimeFormat('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(self.toDateObj(e.detail.date));
                            if (self.dayTickets) {
                                self.getDayOrderUrl();
                            } else {
                                self.getEveningList(e.detail.date);
                            }
                        } else {
                            self.chosenDate = '';
                        }
                    });
                    this.$refs.datepicker.addEventListener('change', (e) => {
                        if (e.target.value === '') {
                            self.chosenDate = '';
                        }
                    });
                }
            });
        },
        async fetchData(api) {
            try {
                const response = await axios.post(api, this.queryModel);
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        getDayOrderUrl() {
            const filteredItem = this.dayItems.filter(item => item[this.constants.keys.date] === this.reverseDate(this.chosenDate).replaceAll('/','-'));
            if (filteredItem.length) {
                this.dayUrl = filteredItem[0].ticketUrl;
            } else {
                this.dayUrl = '';
            }
        },
        getEveningList(date) {
            const targetDate = new Date(date);
            const targetDateISO = `${targetDate.getFullYear()}-${String(targetDate.getMonth() + 1).padStart(2, '0')}-${String(targetDate.getDate()).padStart(2, '0')}`;
            this.eveningMovies = Object.entries(this.eveningItems).filter(([key]) => key.startsWith(targetDateISO)).flatMap(([, items]) => items);
        },
        reverseDate(dateString) {
            var dateStringComps = dateString.split('-');
            return dateStringComps[2] + this.delimiter + dateStringComps[1] + this.delimiter + dateStringComps[0]
        },
        formatDate(dateString) {
            return dateString.replaceAll('-', this.delimiter);
        }
    },
    mounted() {
        this.init();
    }
}

export default ticketApp;